<template>
  <v-dialog v-model="value" width="600" persistent>
    <v-form v-model="valid" ref="form">
      <v-card class="w-100 rounded-lg">
        <v-card-title>{{ $t('spedilink.assignToGroup.title') }}</v-card-title>
        <v-card-text>
          <div class="mb-4 text-body-2 grey--text text--darken-1">
            {{ person.firstName }} {{ person.lastName }}
          </div>
          <v-select
            v-model="selectedGroupIds"
            :items="groups"
            :label="$t('spedilink.assignToGroup.selectGroups')"
            item-text="name"
            item-value="id"
            multiple
            outlined
            dense
            :loading="loadingGroups"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0" class="mt-1" small color="primary">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text text-caption mt-1">
                (+{{ selectedGroupIds.length - 1 }} {{ $t('common.others') }})
              </span>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-4 pb-4">
          <v-btn outlined :disabled="loading" @click="close()">
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            class="ml-2"
            :loading="loading"
            :disabled="loading"
            depressed
            @click="save()"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Service from '@/services'

export default {
  name: 'AssignPersonToGroupDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    person: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      valid: true,
      loading: false,
      loadingGroups: false,
      groups: [],
      selectedGroupIds: [],
      originalGroupIds: []
    }
  },
  methods: {
    async open () {
      await this.loadGroups()
      this.selectedGroupIds = this.groups
        .filter(g => g.userIds && g.userIds.includes(this.person.id))
        .map(g => g.id)
      this.originalGroupIds = [...this.selectedGroupIds]
    },
    async loadGroups () {
      this.loadingGroups = true
      try {
        const { data } = await Service.get('spedilink/SpediLinkGroups/GetList', {
          page: 1,
          pageSize: 1000
        })
        this.groups = data.results
      } catch (e) {
      } finally {
        this.loadingGroups = false
      }
    },
    close () {
      this.$emit('close')
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    async save () {
      this.loading = true
      try {
        const added = this.selectedGroupIds.filter(id => !this.originalGroupIds.includes(id))
        const removed = this.originalGroupIds.filter(id => !this.selectedGroupIds.includes(id))

        const updatePromises = []

        for (const groupId of added) {
          const group = this.groups.find(g => g.id === groupId)
          if (group) {
            const newUserIds = [...(group.userIds || []), this.person.id]
            updatePromises.push(
              Service.put('spedilink/SpediLinkGroups/Update', {
                id: group.id,
                name: group.name,
                description: group.description,
                userIds: newUserIds
              })
            )
          }
        }

        for (const groupId of removed) {
          const group = this.groups.find(g => g.id === groupId)
          if (group) {
            const newUserIds = (group.userIds || []).filter(uid => uid !== this.person.id)
            updatePromises.push(
              Service.put('spedilink/SpediLinkGroups/Update', {
                id: group.id,
                name: group.name,
                description: group.description,
                userIds: newUserIds
              })
            )
          }
        }

        await Promise.all(updatePromises)

        if (added.length > 0 || removed.length > 0) {
          await this.$store.dispatch('setSuccessNotification', this.$t('common.confirmOperation'))
        }

        this.$emit('assignment-saved')
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      } catch (e) {
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    value (newVal) {
      if (newVal) {
        this.open()
      }
    }
  }
}
</script>
